import {
  SIZES,
  updateProductBuilderDataRedux,
} from '../components/admin/curator/ProductBuilderComponents/commonHelper';
import {
  CRUD_PRODUCT_BUILDER,
  PRODUCT_BUILDER_PRODUCT_PRESET,
  PRODUCT_BUILDER_PROPERTY,
  PRODUCT_BUILDER_PROPS,
  PRODUCT_BUILDER_TEXTURES,
} from '../config/constant/apiConstant';
import { PRODUCT_BUILDER_PROP_TYPE } from '../constants/constants';
import {
  apiDeleteV2,
  apiGet,
  apiMultiDelete,
  apiPatch,
  apiPostV2,
  CHECK_MATTRESS_AVAILIBILITY,
  MATTRESS_BUILDER_SAVE_AND_MODAL_LIMIT_COUNT_DEDUCT_API,
  PROJECT_MULTI_DELETE,
} from '../helpers/api';
import { fetchAllPages } from '../helpers/apiHelper';
import { dispatcher } from '../helpers/projectHelper';
import {
  productBuilderActions,
  selectProductBuilderPropertyIds,
} from '../redux/slicers/productBuilder/productBuilder.slicer';
import { productBuilderListActions } from '../redux/slicers/productBuilderListSlicer';
import { createGetListAction, createUpdateApiAction } from './apiGenerator';
import { objectToSearchParams } from '../helpers/jsHelper';
import { getAppState } from '../redux/store';
import axios from 'axios';

export const getProductBuilderApi = createGetListAction({
  endpoint: CRUD_PRODUCT_BUILDER,
  actions: productBuilderListActions,
  setGlobalSidebarFilters: true,
});

export const deleteMultipleProductBuilderApi = (
  payload,
  successMessage = 'Mattress Builder deleted successfully',
  errorMessage = 'Unable to delete mattress builder'
) => {
  return apiMultiDelete(
    PROJECT_MULTI_DELETE,
    payload,
    'apiDeleteProjects',
    successMessage,
    errorMessage
  );
};

export const updateProductBuilder = async (data) => {
  const url = `${CRUD_PRODUCT_BUILDER}${data.id}/`;
  try {
    const response = await apiPatch(url, data, null, null, 'Something went wrong', true, false);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export function apiCreateNewProductBuilder(formDataObj) {
  return apiPostV2(CRUD_PRODUCT_BUILDER, { data: formDataObj, isFormData: false }).send();
}

export const apiGetProductBuilderDetail = (id) => {
  const mockDataFetching = async () => {
    const url = `${CRUD_PRODUCT_BUILDER}${id}/`;
    // TODO: add error handling
    const builder = await apiGet(url);
    if (builder) {
      return builder;
    }
    return null;
  };
  return mockDataFetching();
};

export const deleteProductBuilderApi = (id) => async () => {
  let url = CRUD_PRODUCT_BUILDER;
  url += `${id}/`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const apiGetProductBuilderDefaultPropList = async () => {
  const url = `${PRODUCT_BUILDER_PROPS}?is_mattress_builder_default=true`;
  const response = await apiGet(url);
  return response?.results || [];
};

export const apiGetProductBuilderPropListByFilter = async (props) => {
  const params = objectToSearchParams({ sort: '-sequence_number', is_visible: true, ...props });
  const url = `${PRODUCT_BUILDER_PROPS}?${params}`;
  const response = apiGet(url);
  return response;
};

export const addMoreDataToSize = (allData) => {
  const copyData = JSON.parse(JSON.stringify(allData));
  copyData.push(...SIZES);
  return copyData;
};

export const getOnlyPropertyTypeId = (list = []) => {
  const obj = {};
  const allKeys = Object.keys(PRODUCT_BUILDER_PROP_TYPE);
  for (let i = 0; i < allKeys?.length; i++) {
    const keyValue = PRODUCT_BUILDER_PROP_TYPE[allKeys[i]];
    if (keyValue !== 'size' && keyValue !== 'height') {
      const filteredData = list?.find((item) => item?.name?.toLowerCase() === keyValue);
      if (filteredData?.id) {
        obj[keyValue] = filteredData?.id;
      }
    }
  }
  return obj;
};

export const apiGetProductBuilderPropertyByFilter = async ({
  filter_type,
  page = 1,
  perPage = 20,
}) => {
  const _params = objectToSearchParams({
    filter_type,
    page,
    per_page: perPage,
    order_by: 'seq_no',
  });
  const url = `${PRODUCT_BUILDER_PROPERTY}?${_params}`;
  return apiGet(url);
};

export const apiGetAndSetProductBuilderPropertyIds = () => async (dispatch) => {
  const filterType = Object.values(PRODUCT_BUILDER_PROP_TYPE).filter(
    (a) => !['size', 'height'].includes(a)
  );
  const params = objectToSearchParams({
    filter_type: filterType.join(','),
    per_page: 20,
  });
  const url = `${PRODUCT_BUILDER_PROPERTY}?${params}`;
  const firstPageUrl = `${url}&page=1`;
  const firstPageResponse = await apiGet(firstPageUrl);
  const firstPageResults = firstPageResponse?.results || [];
  const totalPages = firstPageResponse?.total_pages || 1;
  if (firstPageResults?.length) {
    const defaultPropertyTypes = getOnlyPropertyTypeId(firstPageResults);
    dispatch(productBuilderActions.setProductBuilderPropertyIds(defaultPropertyTypes));
  }
  const response = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    if (page === 1)
      return {
        results: [],
        total_pages: totalPages,
      };
    return apiGet(paginatedUrl);
  });
  const results = response?.results || [];
  if (results?.length) {
    const otherPropertyTypes = getOnlyPropertyTypeId(results);
    const storedPropertyTypes = selectProductBuilderPropertyIds(getAppState());
    dispatch(
      productBuilderActions.setProductBuilderPropertyIds({
        ...storedPropertyTypes,
        ...otherPropertyTypes,
      })
    );
    dispatch(productBuilderActions.setAllProperties([...firstPageResults, ...results]));
  }
  return {};
};

export const getProductBuilderTextures = (query) => async (dispatch) => {
  let queryString = '';
  let keys = Object.keys(query);
  for (let i = 0; i < keys.length; i++) {
    queryString += keys[i] + '=' + query[keys[i]] + (i !== keys.length - 1 ? '&' : '');
  }
  const url = `${PRODUCT_BUILDER_TEXTURES}?${queryString}&per_page=20`;
  const response = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  dispatch(productBuilderActions.setPatternList(response?.results || []));
};

export const productBuilderUpdateApi = createUpdateApiAction({
  actions: productBuilderListActions,
  endpointUrl: CRUD_PRODUCT_BUILDER,
});

export const updateProductBuilderData =
  (data, isUpdate = true) =>
  async () => {
    const url = `${CRUD_PRODUCT_BUILDER}${data.id}/`;
    try {
      const response = await apiPatch(url, data, null, null, 'Something went wrong', true, false);
      dispatcher(productBuilderActions.setSaveBuilderProjectLoading(false));
      if (response?.data?.id && isUpdate) {
        updateProductBuilderDataRedux(response?.data);
      }
      return response;
    } catch (error) {
      console.error('error', error);
    }
  };

export const saveBuilderToLibrary = async (payload, id) => {
  let url = MATTRESS_BUILDER_SAVE_AND_MODAL_LIMIT_COUNT_DEDUCT_API;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
    showMessage: false,
  }).send();
};

export const checkForMattressBuilderPermission = async () => {
  const response = await apiGet(CHECK_MATTRESS_AVAILIBILITY);
  if (response) {
    return response;
  }
  return false;
};

export const getAllProductBuilderForCheckingPermission = async () => {
  const query = '?per_page=20&search=&page=1&sort=-updated_at';
  const url = `${CRUD_PRODUCT_BUILDER}${query}`;
  const response = await apiGet(url);
  return response?.results || [];
};

export const apiGetTuftPreset = async (props) => {
  const params = objectToSearchParams({ ...props });
  const url = `${PRODUCT_BUILDER_PRODUCT_PRESET}?${params}`;
  const response = apiGet(url);
  return response;
};

export const apiAddTuftPreset = (data) => {
  return apiPostV2(PRODUCT_BUILDER_PRODUCT_PRESET, {
    data,
  }).send();
};

export const apiUpdateTuftPreset = async (data) => {
  const url = `${PRODUCT_BUILDER_PRODUCT_PRESET}${data.id}/`;
  try {
    const response = await apiPatch(url, data, null, null, 'Something went wrong', true, false);
    return response?.data || null;
  } catch (error) {
    console.error('error', error);
    return null;
  }
};

export const apiDeleteTuftPreset = async (id) => {
  let url = PRODUCT_BUILDER_PRODUCT_PRESET;
  url += `${id}/`;
  const result = await apiDeleteV2(url).data().send();
  return result;
};

export const uploadJSONFileToS3 = async ({ file, presigned_data }) => {
  const formData = new FormData();
  Object.entries(presigned_data.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', file);
  return await axios.post(presigned_data.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}